import './chunk-6ea13200.js';
import './helpers.js';
import './chunk-17222463.js';
import './chunk-1f14bcfd.js';
import './chunk-d732d84c.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-322704a2.js';
import { A as Autocomplete } from './chunk-2d63cb07.js';
export { A as BAutocomplete } from './chunk-2d63cb07.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;
